import React from "react"
import "./style/truck.scss"
import truckBody from "@resources/icons/truck-body"
import Icon from "@ng-mw/reol/components/Icon"
import flash from "@resources/icons/flash"

function Truck() {
    const iconSize = { width: "100%", height: "auto" }

    return (
        <div className="truck">
            <div className="truck__flash">
                <Icon
                    icon={flash}
                    size={{ width: "100px", height: "auto" }}
                />
            </div>
            <div className="truck__body">
                <Icon
                    icon={truckBody}
                    size={iconSize}
                />
            </div>
            <div className="truck__wheel truck__wheel--front" />
            <div className="truck__wheel truck__wheel--back" />
        </div>
    )
}

export default Truck
